import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FloorplanSearchService } from '../search/floorplan-search.service';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, ModalController, Platform } from '@ionic/angular';
import { PlacesService } from 'src/app/services/placesService/places.service';
import { Place, UnleashFeatureFlags } from 'src/app/interfaces/interfaces';
import { StringInfoMessageService } from 'src/app/services/string-info-message/string-info-message.service';
import { AvaliableTimeBookingPage } from 'src/app/avaliable-time-booking/avaliable-time-booking.page';
import { EventComponent } from '../event/event.component';
import { ResourceAvailabilityComponent } from '../resource-availability/resource-availability.component';
import { PlacesStore } from '../../stores/places.store';
import { BookingsStore } from 'src/app/stores/bookings.store';
import { UnleashService } from 'src/app/services/unleash/unleash.service';
import { UserStore } from 'src/app/stores/user.store';
import * as moment from 'moment';
import { ToastService } from 'src/app/services/toast-service/toast.service';

export const EVENTPAGETYPES = {
  quickBooking: 'quickBooking',
  scheduledBooking: 'scheduledBooking',
  editBooking: 'editBooking',
  workingHours: 'workTime',
  readOnlyBooking: 'readOnlyBooking',
  slotBooking: 'scheduledBooking',
};

@Component({
  selector: 'app-place',
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.scss']
})
export class PlaceComponent implements OnInit {
  @Input() place: Place;
  @Input() minimalView = false; // this property is for the booking stepper component , for suggested resources
  @Input() forFavorite = false;
  address: string = '';
  isMobile: boolean = false;
  showResourceImages = false;
  unleashFeatureFlags = UnleashFeatureFlags;
  @ViewChild('resourceImagesPopover') resourceImagesPopover;
  constructor(
    private floorplanSearchService: FloorplanSearchService,
    private translateService: TranslateService,
    private actionSheetController: ActionSheetController,
    private placesService: PlacesService,
    private mdlCtrl: ModalController,
    public userStore: UserStore,
    private stringInfoMessageService: StringInfoMessageService,
    private platform: Platform,
    public placesStore: PlacesStore,
    private bookingsStore: BookingsStore,
    public unleashService: UnleashService,
    private toasterService: ToastService
  ) {
    this.isMobile = this.platform.is('mobile') && !this.platform.is('tablet');
  }

  ngOnInit() {
    this.address = this.stringInfoMessageService.buildAddressString(this.place);
  }

  openMap(place) {
    this.floorplanSearchService.openMap(place);
  }

  async toggleFavorite(place) {
    const actionSheet = await this.actionSheetController.create({
    header: place.isFav ? this.translateService.instant('UnfavoriteQuestion') : this.translateService.instant('AddPlaceToFavorites'),
    mode: 'ios',
    buttons: [
      {
        text: this.translateService.instant('feedback.answers.yes'),
        role: 'destructive',
      },
      {
        text: this.translateService.instant('cancelButton'),
        role: 'cancel',
      },
    ],
  });
  await actionSheet.present();
  const result = await actionSheet.onDidDismiss();
    if (result.role === 'destructive') {
      this.placesStore.toggleFavorite(place);
    }
  }

  async showEventModal(place, purpose?: string) {
    if (purpose == 'workingHours') {
      const start = moment()
        .set('hours', this.userStore.user().workingHours.startTime.hour)
        .set('minutes', this.userStore.user().workingHours.startTime.minute)
        .toDate();
      const end = moment()
        .set('hours', this.userStore.user().workingHours.endTime.hour)
        .set('minutes', this.userStore.user().workingHours.endTime.minute)
        .toDate();

      const isPlaceAvailableDuringWorkingHours =
        await this.placesStore.fetchOnePlaceAvailability(
          start,
          end,
          null,
          null,
          null,
          place
        );
      if (!isPlaceAvailableDuringWorkingHours) {
        this.toasterService.openErrorToastAsync(
          this.translateService.instant('placeUnavailableDuringWorkingHours')
        );
        return;
      }
    }
    const modal: HTMLIonModalElement = await this.mdlCtrl.create({
      component: EventComponent,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      handle: false,
      canDismiss: async (data, role) => role != 'gesture',
      componentProps: {
        place: place,
        purpose: purpose
          ? purpose
          : this.placesStore.searchRequestType() != ''
          ? 'plannedBook'
          : 'book',
      },
    });
    modal.present();
  }

  async showAvailableTimeModal(place) {
    const modal: HTMLIonModalElement = await this.mdlCtrl.create({
      component: AvaliableTimeBookingPage,
      initialBreakpoint: 0.95,
      breakpoints: [0, 0.95],
      handle: false,
      canDismiss: async (data, role) => role != 'gesture',
      componentProps: {
        place: place,
      },
    });
    modal.present();
  }

  async showResourceAvailability(place, event?: Event) {
    event?.stopPropagation();
    const modal: HTMLIonModalElement = await this.mdlCtrl.create({
      component: ResourceAvailabilityComponent,
      handle: false,
      canDismiss: async (data, role) => role != 'gesture',
      cssClass: 'resource-availability-modal',
      componentProps: {
        place: place,
      },
    });
    modal.present();
  }

  toggleImageContainer(event?) {
    this.showResourceImages = !this.showResourceImages;
    if (this.resourceImagesPopover) {
      this.resourceImagesPopover.event = event;
    }
  }
}
